module.exports = __webpack_public_path__ + "static/media/emoji-sing-right-note-svgrepo-com.c9716cf4.svg";